import CheckBox from "./fields/CheckBox";
import CommonChoose from "./fields/CommonChoose";
import CommonSelection from "./fields/CommonSelection";
import DateAndTime from "./fields/DateAndTime";
import DateCustom from "./fields/DateCustom";
import InputNumber from "./fields/InputNumber";
import LabelField from "./fields/LabelField";
import LinkCusTom from "./fields/LinkCusTom";
import RadioButton from "./fields/RadioButton";
import RichText from "./fields/RichText";
import TableCusTom from "./fields/TableCusTom";
import Text from "./fields/Text";
import TextAreaCustom from "./fields/TextAreaCustom";
import Attachment from "./fields/Attactment";
import TimeCustom from "./fields/TimeCustom";
import HorizontalBorder from "./fields/HorizontalBorder";
import VerticalBorder from "./fields/VerticalBorder";

import {
  APP_PART_TYPES,
  COLUMN_WIDTH,
} from "@lhd/features/Apps/AppForm/constants";
import { AppPartType, TItemAttachment } from "@lhd/features/Apps/AppForm/types";
import {
  getConfigAppPartType,
  getPrimaryCompanyNameDisplayText,
} from "@lhd/features/Apps/utils";
import AutoFill from "./fields/AutoFill";
import {
  AppRecordV2,
  AppRecordValueV2,
  AppSelectionList,
  CONTRACT_STATUS,
  IPermissionItem,
  TableData,
} from "@lhd/types";

import { isBlankOrNullStatus, parseJson } from "@lhd/utility";
import {
  getTextSection,
  isCategoryField,
  isCategoryOrStatusField,
} from "./fieldUtils";

import { getDisplayText } from "@lhd/features/Apps/AppList/ManagementAppSheet/ManagementAppSheetList/utility";

import SafeHtml from "../SafeHtml";
import TextToolTip from "../TextToolTip";
import { ROUTES } from "@lhd/constants";
import Signature from "./fields/Signature";
import StatusContact from "./fields/StatusContact";
import {
  APP_TYPES,
  SELECTIONS_APP_PARTS,
  SEPARATE,
  STATUS_CONTACT_LABEL_MAP,
} from "./constants";
import { toNumber } from "lodash";
import TableSheet from "./fields/TableSheet";
import { FormInstance } from "antd";
import dayjs from "dayjs";
import { HIDDENS_COLUMNS_SHEET } from "@lhd/features/Apps/constants";

const getOptions = (item: AppPartType, selectionDataList: AppSelectionList) => {
  const rawDataOptions =
    selectionDataList[item.app_part_type as keyof typeof selectionDataList];

  if (rawDataOptions) {
    return (
      rawDataOptions?.map((item: any) => {
        return {
          value: item.id,
          label:
            item.first_name && item.last_name
              ? `${item.first_name} ${item.last_name}`
              : item.full_name || item.name,
        };
      }) || []
    );
  }

  return [];
};

export {
  getOptionsFormAppPart,
  getRuleValidation,
  getTextSection,
} from "./fieldUtils";

export const renderField = (
  item: AppPartType,
  selectionDataList: AppSelectionList,
  option?: {
    namePath?: string | string[];
    isDisabled?: boolean;
    isTable?: boolean;
    permission?: IPermissionItem;
    onChange?: () => void;
    records?: AppRecordV2;
    isPDF?: boolean;
    allowSearchDate?: boolean;
    form?: FormInstance;
    appType?: string;
    appId?: string;
    recordId?: string;
    handleImportTableRows?: (tableItem: AppPartType, rows: string[][]) => void;
    onPrintPDF?: () => void;
    isPrinting?: boolean;
    isCreate?: boolean;
    appParts?: AppPartType[];
    appPartsFlat?: AppPartType[];
    isQuickViewMode?: boolean;
  },
) => {
  const namePath = option?.namePath || getConfigAppPartType(item).namePath;
  const isTable = option?.isTable || false;
  const isDisableFieldOfBusinessTripReports =
    option?.appType === APP_TYPES.BUSINESS_TRIP_REPORTS &&
    (item.field_code === "ステータス" ||
      item?.field_code === "status" ||
      item?.field_code === "application_creator" ||
      item?.field_code === "application_approver" ||
      item?.field_code === "application_date" ||
      item?.field_code === "approval_date" ||
      item?.field_code === "total_settlement_request_amount" ||
      item?.field_code === "settlement_date");
  const isDisabled =
    option?.isDisabled || isDisableFieldOfBusinessTripReports || false;
  const permission = option?.permission;
  const isPDF = option?.isPDF || false;
  const allowSearchDate = option?.allowSearchDate;
  const form = option?.form;
  const commonProps = {
    ...option,
    isTable,
    namePath: namePath || [],
    item,
    permission,
    isPDF,
    appType: option?.appType,
    isDisabled,
    appId: String(option?.records?.app_id || ""),
    recordId: String(option?.records?.id || ""),
  };
  const { nameItem } = getConfigAppPartType(item);

  if (SELECTIONS_APP_PARTS.includes(item.app_part_type)) {
    return (
      <CommonSelection
        {...commonProps}
        options={getOptions(item, selectionDataList)}
        loading={
          !selectionDataList[
            item.app_part_type as keyof typeof selectionDataList
          ]
        }
      />
    );
  }
  switch (item.app_part_type) {
    case APP_PART_TYPES.VERTICAL_BORDER:
      return <VerticalBorder {...commonProps} />;
    case APP_PART_TYPES.HORIZONTAL_BORDER:
      return <HorizontalBorder {...commonProps} />;
    case APP_PART_TYPES.LABEL:
      return <LabelField {...commonProps} />;
    case APP_PART_TYPES.MULTI_CHOICE:
    case APP_PART_TYPES.DROPDOWN:
      return <CommonChoose {...commonProps} onChange={option?.onChange} />;
    case APP_PART_TYPES.DATE:
      return (
        <DateCustom
          {...commonProps}
          allowSearchDate={allowSearchDate}
          form={form}
          appPartsFlat={option?.appPartsFlat || (option as any)?.appParts}
          onChange={option?.onChange}
        />
      );
    case APP_PART_TYPES.TEXT:
      return <Text {...commonProps} />;
    case APP_PART_TYPES.TIME:
      return <TimeCustom {...commonProps} />;
    case APP_PART_TYPES.CHECK_BOX:
      return <CheckBox {...commonProps} />;
    case APP_PART_TYPES.DATE_AND_TIME:
      return <DateAndTime {...commonProps} nameItem={nameItem} />;
    case APP_PART_TYPES.WORKER_SELECTION:
    case APP_PART_TYPES.ORGANIZATION_SELECTION:
    case APP_PART_TYPES.DIVISION_SELECTION:
    case APP_PART_TYPES.BRANCH_SELECTION:
    case APP_PART_TYPES.DEPARTMENT_SELECTION:
    case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
    case APP_PART_TYPES.REPRESENTATIVE_SELECTION:
    case APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION:
      return (
        <CommonSelection
          {...commonProps}
          options={getOptions(item, selectionDataList)}
          loading={
            !selectionDataList[
              item.app_part_type as keyof typeof selectionDataList
            ]
          }
        />
      );
    case APP_PART_TYPES.PRIMARY_COMPANY_NAME:
      return (
        <AutoFill {...commonProps}>
          {getPrimaryCompanyNameDisplayText()}
        </AutoFill>
      );
    case APP_PART_TYPES.NUMBER:
      return <InputNumber {...commonProps} />;
    case APP_PART_TYPES.RADIO_BUTTON:
      return <RadioButton {...commonProps} />;
    case APP_PART_TYPES.TEXT_AREA:
      return <TextAreaCustom {...commonProps} />;
    case APP_PART_TYPES.TABLE:
      return isPDF ? (
        <TableCusTom
          {...commonProps}
          selectionDataList={selectionDataList}
          onChange={option?.onChange}
        />
      ) : (
        <TableSheet
          {...(commonProps as any)}
          permission={{
            ...commonProps.permission,
            delete: commonProps.permission?.edit,
          }}
          selectionDataList={selectionDataList}
          tableData={option?.records?.table_data.find(
            (tableData) => Number(tableData.table_id) === Number(item.id),
          )}
        />
      );
    case APP_PART_TYPES.ATTACHMENT:
      return <Attachment {...commonProps} onDelete={option?.onChange} />;
    case APP_PART_TYPES.LINK:
      return <LinkCusTom {...commonProps} />;
    case APP_PART_TYPES.RICH_TEXT:
      return <RichText {...commonProps} onChange={option?.onChange} />;
    case APP_PART_TYPES.SIGNED_DATE:
      return null;
    case APP_PART_TYPES.SIGNATURE:
      return <Signature {...commonProps} />;
    case APP_PART_TYPES.STATUS_CONTRACT:
      return <StatusContact {...(commonProps as any)} />;
  }
  return (
    <div style={{ background: "red" }}>
      {item.app_part_type} {APP_PART_TYPES.STATUS_CONTRACT}
    </div>
  );
};

const convertValueToForm = (
  appPart: AppPartType,
  recordValue: AppRecordValueV2,
) => {
  if (recordValue.value === null || recordValue.value === undefined) {
    if (
      appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE ||
      appPart?.app_part_type === APP_PART_TYPES.CHECK_BOX
    ) {
      return [];
    }
    return undefined;
  }

  // Clear blank or sentinel null values for category and status fields
  if (
    isCategoryOrStatusField(appPart) &&
    isBlankOrNullStatus({
      value: recordValue.value,
      name: String(recordValue.value),
    })
  ) {
    if (
      appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE ||
      appPart?.app_part_type === APP_PART_TYPES.CHECK_BOX
    ) {
      return [];
    }
    return undefined;
  }

  const isCompanyPoliciesCategoryPart =
    appPart?.parent_id == null &&
    appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE &&
    (appPart?.field_code === "カテゴリー" ||
      appPart?.name === "カテゴリー" ||
      isCategoryField(appPart));

  if (isCompanyPoliciesCategoryPart) {
    if (
      recordValue?.value === null ||
      recordValue?.value === undefined ||
      recordValue?.value === "" ||
      isBlankOrNullStatus({
        value: recordValue?.value,
        name: String(recordValue?.value),
      })
    ) {
      return [];
    }
    if (Array.isArray(recordValue.value)) {
      return recordValue.value
        .map((v) => Number(v))
        .filter((v) => Number.isInteger(v));
    }
    const num = Number(recordValue.value);
    return Number.isInteger(num) ? [num] : [];
  }

  const isBusinessManualsCategoryPart =
    appPart?.parent_id == null &&
    (appPart?.field_code === "カテゴリ" ||
      appPart?.field_code === "category" ||
      appPart?.name === "カテゴリ" ||
      appPart?.name === "カテゴリー");

  const isBusinessManualsStatusPart =
    appPart?.parent_id == null &&
    (appPart?.field_code === "status_slicer" ||
      appPart?.field_code === "status_filter" ||
      appPart?.name === "ステータス");

  if (isBusinessManualsCategoryPart) {
    if (
      recordValue?.value === null ||
      recordValue?.value === undefined ||
      recordValue?.value === "" ||
      isBlankOrNullStatus({
        value: recordValue?.value,
        name: String(recordValue?.value),
      })
    ) {
      return [];
    }
    if (Array.isArray(recordValue.value)) {
      return recordValue.value
        .map((v) => Number(v))
        .filter((v) => Number.isInteger(v));
    }
    const num = Number(recordValue.value);
    return Number.isInteger(num) ? [num] : [];
  }

  if (isBusinessManualsStatusPart) {
    if (
      recordValue?.value === null ||
      recordValue?.value === undefined ||
      recordValue?.value === "" ||
      isBlankOrNullStatus({
        value: recordValue?.value,
        name: String(recordValue?.value),
      })
    ) {
      return undefined;
    }
    const num = Number(recordValue.value);
    return Number.isInteger(num) ? num : undefined;
  }

  if (
    appPart?.app_part_type &&
    SELECTIONS_APP_PARTS.includes(appPart.app_part_type as any)
  ) {
    let values = recordValue.value || [];

    if (appPart?.app_part_type === APP_PART_TYPES.WORKER_SELECTION) {
      values = Array.isArray(values)
        ? values.map((v) => Number(v))
        : Number(values);
    }

    const isSingleSelect =
      appPart.field_code === "business_trip_expense_applicant" ||
      appPart.field_code === "department_selection";
    if (isSingleSelect) {
      return Array.isArray(values)
        ? values.length > 0
          ? values[0]
          : undefined
        : values;
    }
    return values;
  } else if (appPart?.app_part_type === APP_PART_TYPES.ATTACHMENT) {
    return getValueFormatByAppPart(appPart, recordValue);
  } else if (
    appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE ||
    appPart?.app_part_type === APP_PART_TYPES.CHECK_BOX
  ) {
    if (Array.isArray(recordValue?.value)) return recordValue.value;
    return recordValue?.value && typeof recordValue.value === "string"
      ? recordValue?.value?.split(SEPARATE)
      : [];
  }
  return recordValue.value ?? "";
};

export const applyWorkerSelectionSingleToForm = (
  formValues: Record<string, any>,
  appParts: AppPartType[],
) => {
  appParts.forEach((appPart) => {
    if (appPart.app_part_type !== APP_PART_TYPES.WORKER_SELECTION) return;
    const namePath = getConfigAppPartType(appPart).namePath;
    const key = namePath.join(".");
    const value = formValues[key];
    if (Array.isArray(value)) {
      formValues[key] = value.length > 0 ? value[0] : undefined;
    }
  });
  return formValues;
};

export const convertDataToDataForm = (
  appParts: AppPartType[],
  appRecord: AppRecordV2,
  isPDF?: boolean,
) => {
  const result = {} as Record<string, any>;
  const appPartsObject = buildAppPartTypeObject(appParts);

  // Initialize all configurable app parts so fields absent in regular_values
  // (e.g., null status) are explicitly cleared when resetting or switching records
  appParts.forEach((appPart) => {
    if (appPart?.item_config_data && !appPart.parent_id) {
      const namePath = getConfigAppPartType(appPart).namePath;
      if (namePath?.length) {
        if (
          appPart.app_part_type === APP_PART_TYPES.MULTI_CHOICE ||
          appPart.app_part_type === APP_PART_TYPES.CHECK_BOX
        ) {
          result[namePath.join(".")] = [];
        } else {
          result[namePath.join(".")] = undefined;
        }
      }
    }
  });

  appRecord.regular_values?.forEach((recordValue) => {
    const appPart = appPartsObject[String(recordValue.app_part_id)];
    if (!appPart) return;
    const namePath = getConfigAppPartType(appPart).namePath;
    result[namePath.join(".")] = convertValueToForm(appPart, recordValue);
    result[namePath.join(".") + ".background_color"] =
      recordValue.background_color;
    result[namePath.join(".") + ".text_color"] = recordValue.text_color;
  });
  if (appRecord.table_data?.length && isPDF) {
    result["tables"] = {};
    appRecord.table_data.forEach((tableData) => {
      if (!result.tables[tableData.table_id]) {
        result.tables[tableData.table_id] = { value: {} };
      }
      tableData.rows.forEach((row) => {
        if (!result.tables[tableData.table_id]["value"][row.client_id]) {
          result.tables[tableData.table_id]["value"][row.client_id] = {
            row_order: row.row_order,
            info: {
              row_id: row.row_id,
              isOld: true,
              isDeleted: false,
            },
          };
        }

        row.cells.forEach((cell) => {
          const appPart = appPartsObject[String(cell.app_part_id)];
          if (appPart) {
            result.tables[tableData.table_id]["value"][row.client_id][
              cell.app_part_id
            ] = convertValueToForm(appPart, cell);
          }
        });
      });
    });
  }

  //shape of result = {
  // [app_part_id outside table] : any value,
  // tables: {
  //  [some special filed such as _destroy] : any value
  //   value: {
  //     [client_id]: {
  //       [app_part_id] : any value,
  //       info? : {
  //             row_id: row.row_id,
  //             isOld: true,
  //             isDeleted: false,
  //        }
  //     }
  //   }
  // }
  //}
  return result;
};

export const STATUS_BANNED = {
  statusName: "ステータス",
  statusValue: "使用禁止",
  categoryName: "カテゴリー",
};

const convertDataRawToJSON = (
  valueRaw: any,
  appPart: AppPartType,
  appType?: string,
) => {
  if (
    appPart?.app_part_type &&
    SELECTIONS_APP_PARTS.includes(appPart.app_part_type as any)
  ) {
    if (Array.isArray(valueRaw) && valueRaw.length === 0) return null;
    return valueRaw || null;
  }
  if (appPart?.app_part_type === APP_PART_TYPES.ATTACHMENT) {
    const valueString = (valueRaw || []).map((x: TItemAttachment) => ({
      url: x.url,
      is_allow_download_attachment: Boolean(x.is_allow_download_attachment),
    }));
    return JSON.stringify(valueString);
  }
  if (appType === APP_TYPES.COMPANY_POLICIES) {
    if (
      appPart?.app_part_type === APP_PART_TYPES.DROPDOWN &&
      appPart?.name === STATUS_BANNED.statusName
    ) {
      const catalogId = Number(valueRaw);
      return valueRaw && Number.isInteger(catalogId) ? catalogId : null;
    } else if (
      appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE &&
      (appPart?.name === STATUS_BANNED.categoryName ||
        appPart?.field_code === STATUS_BANNED.categoryName ||
        isCategoryField(appPart))
    ) {
      if (Array.isArray(valueRaw)) {
        return valueRaw
          .filter(
            (v) =>
              v !== undefined &&
              v !== null &&
              v !== "" &&
              !isBlankOrNullStatus({ value: v, name: String(v) }),
          )
          .map((v) => toNumber(v))
          .filter((v) => Number.isInteger(v));
      }
      if (
        valueRaw !== undefined &&
        valueRaw !== null &&
        valueRaw !== "" &&
        !isBlankOrNullStatus({ value: valueRaw, name: String(valueRaw) })
      ) {
        const num = toNumber(valueRaw);
        if (Number.isInteger(num)) {
          return [num];
        }
      }
      return [];
    }
  }

  if (appType === APP_TYPES.BUSINESS_MANUALS) {
    const isStatus =
      appPart?.parent_id == null &&
      (appPart?.field_code === "status_slicer" ||
        appPart?.field_code === "status_filter" ||
        appPart?.name === "ステータス");
    const isCategory =
      appPart?.parent_id == null &&
      (appPart?.field_code === "カテゴリ" ||
        appPart?.field_code === "category" ||
        appPart?.name === "カテゴリ" ||
        appPart?.name === "カテゴリー");

    if (isStatus) {
      if (
        valueRaw === undefined ||
        valueRaw === null ||
        valueRaw === "" ||
        isBlankOrNullStatus({ value: valueRaw, name: String(valueRaw) })
      ) {
        return null;
      }
      const catalogId = Number(valueRaw);
      return Number.isInteger(catalogId) ? catalogId : null;
    } else if (isCategory) {
      if (Array.isArray(valueRaw)) {
        return valueRaw
          .filter(
            (v) =>
              v !== undefined &&
              v !== null &&
              v !== "" &&
              !isBlankOrNullStatus({ value: v, name: String(v) }),
          )
          .map((v) => toNumber(v))
          .filter((v) => Number.isInteger(v));
      }
      if (
        valueRaw !== undefined &&
        valueRaw !== null &&
        valueRaw !== "" &&
        !isBlankOrNullStatus({ value: valueRaw, name: String(valueRaw) })
      ) {
        const num = toNumber(valueRaw);
        if (Number.isInteger(num)) {
          return [num];
        }
      }
      return [];
    }
  }

  if (
    appPart?.app_part_type === APP_PART_TYPES.MULTI_CHOICE ||
    appPart?.app_part_type === APP_PART_TYPES.CHECK_BOX
  ) {
    return valueRaw?.join(SEPARATE) || "";
  }
  if (typeof valueRaw === "string") return valueRaw;

  return "";
};

export const dataDataValueToForm = (
  data: Record<string, AppRecordValueV2>,
  appPartObj: Record<string, AppPartType>,
) => {
  const result: Record<string, any> = {};
  Object.keys(data).forEach((key: keyof typeof data) => {
    const appPart = appPartObj[key];
    const recordValue = data[key];
    result[key] = convertValueToForm(appPart, recordValue);
  });

  return result;
};

export const dataFormToDataSubmit = (
  data: Record<string, any> = {},
  appPartObj: Record<string, AppPartType>,
  appType?: string,
) => {
  const result: typeof data = {};
  Object.keys(data).forEach((key: keyof typeof data) => {
    const valueRaw = data[key];
    const appPart = appPartObj[key];
    const value = convertDataRawToJSON(valueRaw, appPart, appType);
    result[key] = value;
  });
  return result;
};

export function buildTreeAppPartType(list: AppPartType[]) {
  const nodeMap = new Map();
  const roots: AppPartType[] = [];

  // Tạo node và children rỗng
  list.forEach((item) => {
    nodeMap.set(item.id, { ...item, children: [] });
  });

  // Gán cha - con
  list.forEach((item) => {
    const node = nodeMap.get(item.id) as AppPartType;
    node.item_config_data = parseJson(
      node.item_config_data,
      node.item_config_data,
    );
    if (item.parent_id) {
      const parent = nodeMap.get(item.parent_id);
      if (parent) {
        parent.children.push(node);
      }
    } else {
      roots.push(node);
    }
  });

  return roots;
}

export function parseAppPartType(list: AppPartType[]) {
  list.forEach((item) => {
    item.item_config_data = parseJson(
      item.item_config_data,
      item.item_config_data,
    );
    if (item.children?.length) {
      parseAppPartType(item.children);
    }
  });
  return list;
}

export function buildAppPartTypeObject(list: AppPartType[]) {
  return list.reduce((acc, cur: AppPartType) => {
    acc[String(cur.id)] = cur;
    return acc;
  }, {} as Record<string, AppPartType>);
}

export function flattenAppParts(list: AppPartType[]): AppPartType[] {
  const result: AppPartType[] = [];
  const walk = (items: AppPartType[]) => {
    items.forEach((item) => {
      result.push(item);
      if (item.children?.length) walk(item.children);
    });
  };
  walk(list);
  return result;
}

export const getStatusContractText = (contractStatus: string) => {
  switch (contractStatus) {
    case CONTRACT_STATUS.PENDING_SIGNATURE:
      return STATUS_CONTACT_LABEL_MAP.PENDING_SIGNATURE;
    case CONTRACT_STATUS.ACTIVE:
      return STATUS_CONTACT_LABEL_MAP.ACTIVE;
    case CONTRACT_STATUS.ARCHIVED:
      return STATUS_CONTACT_LABEL_MAP.ARCHIVED;
    default:
      return STATUS_CONTACT_LABEL_MAP.DRAFTING;
  }
};

export function getValueFormatByAppPart(
  appPart: AppPartType,
  appRecordValue: AppRecordValueV2,
  selectionDataList?: AppSelectionList,
  optionParams?: { omitUnknownSelection?: boolean },
) {
  if (
    appRecordValue?.valueFormat !== undefined &&
    appRecordValue?.valueFormat !== null &&
    appRecordValue?.valueFormat !== ""
  ) {
    return appRecordValue.valueFormat;
  }

  if (SELECTIONS_APP_PARTS.includes(appPart.app_part_type)) {
    return appRecordValue?.value
      ? getTextSection(appRecordValue?.value, appPart, selectionDataList, {
          omitUnknown: optionParams?.omitUnknownSelection,
        })
      : "";
  }

  switch (appPart.app_part_type) {
    case APP_PART_TYPES.SIGNED_DATE:
      return appRecordValue?.value
        ? dayjs(appRecordValue?.value).format("YYYY年MM月DD日")
        : "";
    case APP_PART_TYPES.DATE:
    case APP_PART_TYPES.TIME:
    case APP_PART_TYPES.DATE_AND_TIME:
    case APP_PART_TYPES.NUMBER:
      return appRecordValue?.value
        ? getDisplayText(appPart, appRecordValue?.value)
        : "";
    case APP_PART_TYPES.STATUS_CONTRACT:
      return appRecordValue?.value
        ? getStatusContractText(appRecordValue?.value)
        : "";
    case APP_PART_TYPES.WORKER_SELECTION: {
      const raw = appRecordValue?.value;
      let values: any[] = [];
      if (Array.isArray(raw)) {
        values = raw;
      } else if (raw !== undefined && raw !== null && raw !== "") {
        if (typeof raw === "string" && raw.startsWith("[")) {
          values = parseJson(raw, []);
        } else {
          values = [Number(raw)];
        }
      }
      return values && values.length
        ? getTextSection(values as number[], appPart, selectionDataList)
        : "";
    }
  }

  const options = appPart.item_config_data?.options;
  if (Array.isArray(options) && options.length > 0) {
    const rawVal = appRecordValue?.value;
    if (rawVal !== undefined && rawVal !== null && rawVal !== "") {
      let values: any[] = [];
      if (Array.isArray(rawVal)) {
        values = rawVal;
      } else if (typeof rawVal === "string" && rawVal.startsWith("[")) {
        values = parseJson(rawVal, []);
      } else {
        values = [rawVal];
      }
      const labels = values
        .map((v) => {
          const found = options.find(
            (opt: any) =>
              String(opt.value) === String(v) ||
              String(opt.filter_value) === String(v) ||
              String(opt.text) === String(v),
          );
          return found ? found.text : String(v);
        })
        .filter((label) => label && label !== "(空白)");
      return labels.join(", ");
    }
    return "";
  }

  return appRecordValue?.value;
}

/** Rows for CSV/Excel: optional header (column labels), then one row per table row. */
export function tableDataToExportMatrix(
  columnParts: AppPartType[],
  tableData: TableData | undefined,
  options?: { includeHeader?: boolean; title?: string },
): string[][] {
  const sortedColumnParts = [...columnParts].sort(
    (a, b) => a.item_config_data.x - b.item_config_data.x,
  );
  const matrix: string[][] = [];
  matrix.push([...sortedColumnParts.map((col) => col.name ?? "111")]);

  const dataRows = tableData?.rows ?? [];
  for (const row of dataRows) {
    const byPart: Record<string, AppRecordValueV2> = {};
    row.cells.forEach((cell) => {
      byPart[String(cell.app_part_id)] = cell;
    });
    matrix.push(
      sortedColumnParts.map((col) => {
        const cell = byPart[String(col.id)];
        if (!cell) return "";
        const raw = getValueFormatByAppPart(col, cell);
        if (raw == null) return "";
        return String(raw).replace(/\r\n|\n|\r/g, " ");
      }),
    );
  }
  return matrix;
}

export function stringifyCsvMatrix(rows: string[][]): string {
  const esc = (val: string) => {
    if (/[",\n\r]/.test(val)) {
      return `"${val.replace(/"/g, '""')}"`;
    }
    return val;
  };
  return rows.map((line) => line.map(esc).join(",")).join("\r\n");
}

export function renderValueViewCell(appPart: AppPartType, valueRaw: any) {
  switch (appPart.app_part_type) {
    case APP_PART_TYPES.DATE:
    case APP_PART_TYPES.TIME:
    case APP_PART_TYPES.DATE_AND_TIME:
    case APP_PART_TYPES.SIGNED_DATE:
    case APP_PART_TYPES.NUMBER:
      return valueRaw ? getDisplayText(appPart, valueRaw) : "";

    case APP_PART_TYPES.RICH_TEXT:
      return <SafeHtml html={valueRaw} />;
    case APP_PART_TYPES.LINK:
      return (
        <a href={valueRaw} target="_blank" rel="noreferrer">
          <TextToolTip>{valueRaw}</TextToolTip>
        </a>
      );

    case APP_PART_TYPES.TEXT_AREA:
      return <pre>{valueRaw}</pre>;
  }
  return valueRaw;
}

export function getDefaultValueByAppPart(appPart: AppPartType) {
  switch (appPart.app_part_type) {
    case APP_PART_TYPES.ATTACHMENT:
      return [];
  }
  return "";
}

export const getLinkNavigate = () => {
  return `/${ROUTES.COMPANY_POLICIES}`;
};

type NewStateFilter = {
  sort: Record<string, string[]>;
  filters: Record<string, any[]>;
  search: Record<string, any[]>;
  notFound: boolean;
};
function convertJPDate(text: string) {
  return text
    .replace(/^(\d{4})年(\d{2})月(\d{2})日$/, "$1-$2-$3")
    .replace(/^(\d{4})年(\d{2})月$/, "$1-$2")
    .replace(/^(\d{4})年$/, "$1");
}

export function getValueNumberRawFromValueFormat(
  appPart: AppPartType,
  value: any,
) {
  switch (appPart.app_part_type) {
    case APP_PART_TYPES.NUMBER:
      return value ? getDisplayText(appPart, value) : "";
  }
  return value;
}

export function convertTableFilter(
  oldState: Record<string, Record<string, any>>,
  appParts: AppPartType[],
  appType?: string,
): NewStateFilter {
  const result: NewStateFilter = {
    sort: {},
    filters: {},
    search: {},
    notFound: false,
  };
  const valueFilterSpecialEmpty = ["__NULL__", "__EMPTY__"];

  Object.entries(oldState).forEach(([columnId, config]) => {
    const appPart = appParts.find((ap) => String(ap.id) === columnId);
    const isFilterSpecialEmpty = config.filter_special_empty;
    const filterOptions = config.filterOptions;
    if (!appPart) return;
    // sort
    if (config.sort) {
      result.sort[columnId] = config.sort;
    }

    if (
      config.filter === undefined &&
      !config.search &&
      !isFilterSpecialEmpty
    ) {
      return;
    }

    let values: any[] = [];
    let hasExplicitFilter = false;

    // filter
    if (config.filter !== undefined) {
      hasExplicitFilter = true;
      if (Array.isArray(config.filter)) {
        values = config.filter;
      } else if (typeof config.filter === "object") {
        values = Object.keys(config.filter).filter(
          (key) => config.filter[key] === true,
        );
      } else {
        values = [config.filter];
      }
    }

    if (config.search?.trim()) {
      if (isFilterSpecialEmpty && hasExplicitFilter && values.length === 0) {
        // if we search and filter is empty, we should not found , stop process
        result.notFound = true;
        return;
      }
      const filterOptionsSearch = filterOptions.filter((option: any) =>
        option.label.toLowerCase().includes(config.search.trim().toLowerCase()),
      );
      if (hasExplicitFilter) {
        values = values.filter((value) => {
          if (
            appPart.app_part_type === APP_PART_TYPES.DATE ||
            appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
          ) {
            return filterOptionsSearch.some((option: any) =>
              option.label.toLowerCase().includes(value.toLowerCase()),
            );
          } else {
            return filterOptionsSearch.some((option: any) =>
              option.value.toString().includes(value.toString()),
            );
          }
        });
        if (
          appPart.app_part_type === APP_PART_TYPES.DATE ||
          appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
        ) {
          values = filterOptionsSearch
            .filter((option: any) =>
              values.some((v) => option.label.includes(v)),
            )
            .map((option: any) => option.value);
        }
      } else {
        values = filterOptionsSearch.map((option: any) => option.value);
      }

      if (values.length === 0) {
        result.notFound = true;
        return;
      }
    } else {
      if (hasExplicitFilter && values.length === 0 && !isFilterSpecialEmpty) {
        result.notFound = true;
        return;
      }
    }
    if (values.length > 0) {
      if (
        appPart.app_part_type === APP_PART_TYPES.DATE ||
        appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
      ) {
        values = values.map((v) => convertJPDate(v));
      }
    }
    if (isFilterSpecialEmpty) {
      values = [...values, ...valueFilterSpecialEmpty];
    }

    if (
      (appType === APP_TYPES.COMPANY_POLICIES &&
        (appPart.field_code === "カテゴリー" ||
          appPart.field_code === "ステータス")) ||
      (appType === APP_TYPES.BUSINESS_MANUALS &&
        (appPart.field_code === "カテゴリ" ||
          appPart.field_code === "status_slicer"))
    ) {
      values = values
        .map((v) => {
          if (v === "__NULL__" || v === "__EMPTY__" || v === "(空白)") {
            return "__NULL__";
          }
          const num = Number(v);
          return isNaN(num) ? v : num;
        })
        .filter((v) => v !== undefined && v !== null);
    }

    result.filters[columnId] = Array.from(new Set(values));
  });

  return result;
}
const extractRowValue = (rowValue: Record<string, any>) => {
  const result: Record<string, any> = {};

  Object.keys(rowValue || {}).forEach((fieldId) => {
    const field = rowValue[fieldId];

    // unwrap { value: xxx }
    result[fieldId] = field?.value ?? "";
  });

  return result;
};

export const handleDataSubmitFinish = (
  values: any,
  appPartsFlat: AppPartType[],
  appType?: string,
) => {
  const { tables, ...valueRest } = values;
  const appPartTypeObject = buildAppPartTypeObject(
    flattenAppParts(appPartsFlat),
  );
  const dataSubmit: { values: Record<string, any> } = { values: {} };
  if (tables) {
    const dataSubmitTable: Record<string, any> = {};
    Object.keys(tables).forEach((tableId) => {
      const table = tables[tableId];
      dataSubmitTable[tableId] = [];

      if (table?._destroy?.length) {
        dataSubmitTable[tableId].push(...table._destroy);
      }

      const rowKeys = Object.keys(table || {}).filter(
        (key) => key !== "_destroy",
      );
      rowKeys
        .map((client_id) => ({ client_id, row: table[client_id] }))
        .sort((a, b) => (a.row?.row_order ?? 0) - (b.row?.row_order ?? 0))
        .forEach(({ client_id, row }) => {
          if (!row?.value) return;

          const rawRow = extractRowValue(row.value);
          const dataFormat = dataFormToDataSubmit(rawRow, appPartTypeObject);

          dataSubmitTable[tableId].push({
            ...dataFormat,
            client_id,
            row_order: row.row_order,
          });
        });
    });

    dataSubmit.values = { ...dataSubmit.values, ...dataSubmitTable };
  }
  const dataFormat = dataFormToDataSubmit(
    valueRest,
    appPartTypeObject,
    appType,
  );

  dataSubmit.values = { ...dataSubmit.values, ...dataFormat };

  if (appType === APP_TYPES.COMPANY_POLICIES) {
    Object.values(appPartTypeObject).forEach((appPart) => {
      if (
        appPart.parent_id == null &&
        appPart.app_part_type === APP_PART_TYPES.MULTI_CHOICE &&
        (appPart.field_code === "カテゴリー" ||
          appPart.name === "カテゴリー" ||
          isCategoryField(appPart))
      ) {
        const fieldId = String(appPart.id);
        if (
          dataSubmit.values[fieldId] === undefined ||
          dataSubmit.values[fieldId] === null
        ) {
          dataSubmit.values[fieldId] = [];
        }
      }
    });
  }

  if (appType === APP_TYPES.BUSINESS_MANUALS) {
    Object.values(appPartTypeObject).forEach((appPart) => {
      if (
        appPart.parent_id == null &&
        (appPart.field_code === "カテゴリ" ||
          appPart.field_code === "category" ||
          appPart.name === "カテゴリ" ||
          appPart.name === "カテゴリー")
      ) {
        const fieldId = String(appPart.id);
        if (dataSubmit.values[fieldId] === undefined) {
          dataSubmit.values[fieldId] = [];
        }
      } else if (
        appPart.parent_id == null &&
        (appPart.field_code === "status_slicer" ||
          appPart.field_code === "status_filter" ||
          appPart.name === "ステータス")
      ) {
        const fieldId = String(appPart.id);
        if (dataSubmit.values[fieldId] === undefined) {
          const defNum = Number(appPart.default_value);
          dataSubmit.values[fieldId] =
            appPart.default_value !== undefined &&
            appPart.default_value !== null &&
            appPart.default_value !== "" &&
            Number.isInteger(defNum)
              ? defNum
              : null;
        }
      }
    });
  }

  if (appType === APP_TYPES.BUSINESS_TRIP_REPORTS) {
    const disabledFieldCodes = [
      "ステータス",
      "status",
      "application_creator",
      "application_approver",
      "application_date",
      "approval_date",
      "total_settlement_request_amount",
      "settlement_date",
    ];
    dataSubmit.values = Object.fromEntries(
      Object.entries(dataSubmit.values).filter(([fieldId]) => {
        const appPart = appPartTypeObject[fieldId];
        return (
          !appPart || !disabledFieldCodes.includes(appPart.field_code ?? "")
        );
      }),
    );
  }

  return dataSubmit;
};

export const getWidthByAppPartCompanyPolicies = (appPart: AppPartType) => {
  const width = Math.min(
    Math.max(appPart.item_config_data.w * COLUMN_WIDTH, 200),
    370,
  );
  if (appPart.app_part_type === APP_PART_TYPES.NUMBER) {
    return 60;
  } else if (
    appPart.app_part_type === APP_PART_TYPES.DATE ||
    appPart.app_part_type === APP_PART_TYPES.SIGNED_DATE
  ) {
    return 130;
  } else if (appPart.app_part_type === APP_PART_TYPES.MULTI_CHOICE) {
    return 170;
  } else if (appPart.app_part_type === APP_PART_TYPES.RADIO_BUTTON) {
    return 130;
  } else if (appPart.app_part_type === APP_PART_TYPES.TEXT) {
    return 200;
  } else if (appPart.app_part_type === APP_PART_TYPES.ATTACHMENT) {
    return 200;
  }
  return width;
};

export const handleHiddenAndSortAppPartColumns = (appParts: AppPartType[]) => {
  return appParts
    .filter(
      (appPart) =>
        !HIDDENS_COLUMNS_SHEET.includes(appPart.app_part_type) &&
        appPart.field_code !== "employer_signer_name" &&
        appPart.field_code !== "employee_signer_name",
    )
    .sort((a, b) => Number(a.sort_index || 0) - Number(b.sort_index || 0));
};
